import { NgModule } from '@angular/core';
import { DashboardModule } from '../common/dashboard/dashboard.module';
import { SharedLibsModule } from './shared-libs.module';
import { PermisoDirective } from './directives/permiso.directive';
import { TableComponent } from './components/table/table.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { IconoFiltroComponent } from '../common/components/icono-filtro/icono-filtro.component';
import { PaginacionSuperiorComponent } from '../productos-comercializadores/consultar-productos-comercializadores/components/control-paginacion/paginacion-superior';
import { ButtonComponent } from './components/button/button.component';
import { InputComponent } from './components/input/input.component';
import { InputDateComponent } from './components/input-date/input-date.component';
import { InputTypeaheadComponent } from './components/input-typeahead/input-typeahead.component';

@NgModule({
    imports: [SharedLibsModule, IconoFiltroComponent, ButtonComponent, InputComponent, InputDateComponent, InputTypeaheadComponent, PaginacionSuperiorComponent],
    declarations: [ PermisoDirective, TableComponent, PageHeaderComponent],
    exports: [
        SharedLibsModule,
        DashboardModule,
        PermisoDirective,
        TableComponent,
        PageHeaderComponent,
        InputComponent,
        InputDateComponent,
        InputTypeaheadComponent,
    ],
})
export class SharedModule {}
